import ajax, { AjaxOptions } from './ajax'
import { BACKEND_URL } from './settings'
import { getLang } from './i18n'

export function request(
  method: string,
  url: string,
  opts: AjaxOptions = {}
): Promise<any> {
  url = `${BACKEND_URL}/api${url}`
  opts.headers = opts.headers || {}
  opts.headers['accept'] = 'application/json'
  opts.headers['accept-language'] = getLang()
  return ajax(method, url, opts)
}

export function get(url: string, opts?: AjaxOptions): Promise<any> {
  return request('GET', url, opts || {})
}

export function post(url: string, opts?: AjaxOptions): Promise<any> {
  return request('POST', url, opts || {})
}
